/*
  FoxGlow card tools
  - Photo cropper: when a customer chooses a photo, they position it inside a
    credit-card outline. The cropped card-sized image (600 DPI) replaces the
    chosen file, so it is what gets attached to the order.
  - 3D card preview: a card they can swipe or tap to turn over, updated live.
  - Live character counters for the text boxes.
  Works with snippets/fg-card-customizer.liquid on product pages and in Quick view.
*/
(function () {
  'use strict';
  if (window.fgCardTools) return;
  window.fgCardTools = true;

  var LONG_MM = 85.6, SHORT_MM = 53.98;
  var RATIO = LONG_MM / SHORT_MM;
  var SAFE = 3 / LONG_MM;                  // safe margin, as a share of the long side
  var RAD_L = 3.18 / LONG_MM * 100;         // corner radius, % of the long side
  var RAD_S = 3.18 / SHORT_MM * 100;        // corner radius, % of the short side
  var OUT_LONG = 2022, OUT_SHORT = 1275;    // 600 DPI at card size
  var WIDTH_IN = { landscape: LONG_MM / 25.4, portrait: SHORT_MM / 25.4 };
  var MAX_BYTES = 20 * 1024 * 1024;
  var FORM_SEL = 'form[action*="/cart/add"]:not([id*="installment"])';
  var FILE_SEL = '.card-custom-fields input[type="file"]';

  // Which field shows on which side of the card, for each option.
  var SIDES = {
    text:        { front: { text: 'properties[Custom Text]' }, back: null, layout: true },
    image:       { front: { photo: 'properties[Uploaded Image]' }, back: null, layout: true },
    photoText:   { front: { photo: 'properties[Uploaded Image]' }, back: { text: 'properties[Custom Text]' }, layout: true },
    dual:        { front: { photo: 'properties[Custom Image 1]' }, back: { photo: 'properties[Custom Image 2]' }, layout: true },
    // Message cards: the front design is fixed (landscape); only the back can be turned to portrait.
    legacyText:  { front: { fixed: true }, back: { text: 'properties[Back Text]' }, layout: true, backOnly: true },
    legacyImage: { front: { fixed: true }, back: { photo: 'properties[Back Image]' }, layout: true, backOnly: true }
  };

  var canSwapFiles = (function () {
    try { return typeof DataTransfer === 'function' && !!new DataTransfer().items; } catch (e) { return false; }
  })();
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Option helpers (same rules as the footer field script) ---------- */
  function modeFor(t) {
    t = (t || '').toLowerCase();
    if (t.indexOf('text only') > -1) return 'text';
    if (t.indexOf('photo and text') > -1) return 'photoText';
    if (t.indexOf('dual sided') > -1) return 'dual';
    if (t.indexOf('image only') > -1) return 'image';
    if (t.indexOf('text') > -1) return 'legacyText';
    if (t.indexOf('image') > -1) return 'legacyImage';
    return '';
  }
  function formFor(box) {
    var el = box.parentElement;
    while (el && !el.querySelector(FORM_SEL)) el = el.parentElement;
    return el ? el.querySelector(FORM_SEL) : null;
  }
  function vidOf(form) { var i = form && form.querySelector('[name="id"]'); return i ? String(i.value) : ''; }
  function variantsOf(box) {
    if (box._fgVariants) return box._fgVariants;
    try { box._fgVariants = JSON.parse(box.querySelector('.ccf-variants').textContent); } catch (e) { box._fgVariants = {}; }
    return box._fgVariants;
  }
  function modeOf(box) { return modeFor(variantsOf(box)[vidOf(formFor(box))]); }
  function layoutOf(box) {
    var cfg = SIDES[modeOf(box)];
    return cfg && cfg.layout && box._fgLayout === 'portrait' ? 'portrait' : 'landscape';
  }
  function field(box, name) { return box.querySelector('[name="' + name + '"]'); }
  function sideOfInput(box, input) {
    var cfg = SIDES[modeOf(box)];
    if (cfg && cfg.back && cfg.back.photo === input.name) return 'back';
    return 'front';
  }
  function sig(f) { return f ? f.name + '|' + f.size + '|' + f.lastModified : ''; }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* ---------- Image loading and rendering ---------- */
  function loadImage(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('load')); };
      img.src = url;
    });
  }
  // Smaller copy for smooth dragging on phones; the full photo is used for the final file.
  function previewSource(img) {
    var max = 1600, w = img.naturalWidth, h = img.naturalHeight;
    if (Math.max(w, h) <= max) return img;
    var k = max / Math.max(w, h), c = document.createElement('canvas');
    c.width = Math.round(w * k); c.height = Math.round(h * k);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c;
  }
  function rotatedSize(img, rot) {
    var w = img.naturalWidth, h = img.naturalHeight;
    return rot % 180 ? { w: h, h: w } : { w: w, h: h };
  }
  // Draw the photo so that the point (u, v) of the rotated photo sits at (cx, cy),
  // at `scale` canvas pixels per photo pixel.
  function drawPhoto(ctx, src, img, p, cx, cy, scale) {
    var r = rotatedSize(img, p.rot), W = img.naturalWidth, H = img.naturalHeight;
    ctx.save();
    ctx.translate(cx, cy);
    ctx.scale(scale, scale);
    ctx.translate(-(p.u - 0.5) * r.w, -(p.v - 0.5) * r.h);
    ctx.rotate(p.rot * Math.PI / 180);
    ctx.drawImage(src, -W / 2, -H / 2, W, H);
    ctx.restore();
  }
  function coverScale(img, rot, fw, fh) {
    var r = rotatedSize(img, rot);
    return Math.max(fw / r.w, fh / r.h);
  }
  function clampCenter(img, p, fw, fh) {
    var r = rotatedSize(img, p.rot), s = coverScale(img, p.rot, fw, fh) * p.zoom;
    var hu = fw / s / 2 / r.w, hv = fh / s / 2 / r.h;
    p.u = Math.min(1 - hu, Math.max(hu, p.u));
    p.v = Math.min(1 - hv, Math.max(hv, p.v));
  }
  function outSize(layout) {
    return layout === 'portrait' ? { w: OUT_SHORT, h: OUT_LONG } : { w: OUT_LONG, h: OUT_SHORT };
  }
  // Make the card-sized file the order receives.
  function exportCrop(img, p, layout, side) {
    var o = outSize(layout);
    var q = { u: p.u, v: p.v, zoom: p.zoom, rot: p.rot };
    clampCenter(img, q, o.w, o.h);
    var c = document.createElement('canvas');
    c.width = o.w; c.height = o.h;
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, o.w, o.h);
    ctx.imageSmoothingQuality = 'high';
    drawPhoto(ctx, img, img, q, o.w / 2, o.h / 2, coverScale(img, q.rot, o.w, o.h) * q.zoom);
    var preview = engravedLook(c, layout);
    return new Promise(function (resolve, reject) {
      c.toBlob(function (blob) {
        if (!blob) return reject(new Error('export'));
        var name = 'card-' + side + '-photo-' + layout + '.jpg';
        resolve({ file: new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }), preview: preview });
      }, 'image/jpeg', 0.92);
    });
  }
  // A one-tone version for the 3D preview: light silver where the photo is light,
  // dark card where it is dark, like an engraving on black aluminum.
  function engravedLook(src, layout) {
    var o = layout === 'portrait' ? { w: 420, h: 666 } : { w: 666, h: 420 };
    var c = document.createElement('canvas');
    c.width = o.w; c.height = o.h;
    var ctx = c.getContext('2d');
    ctx.drawImage(src, 0, 0, o.w, o.h);
    try {
      var d = ctx.getImageData(0, 0, o.w, o.h), a = d.data;
      for (var i = 0; i < a.length; i += 4) {
        var g = (0.299 * a[i] + 0.587 * a[i + 1] + 0.114 * a[i + 2]) / 255;
        g = Math.min(1, Math.max(0, (g - 0.5) * 1.12 + 0.5));
        a[i] = 34 + g * 190; a[i + 1] = 35 + g * 191; a[i + 2] = 38 + g * 192;
      }
      ctx.putImageData(d, 0, 0);
    } catch (e) { /* keep the colour copy if pixels can't be read */ }
    return c.toDataURL('image/jpeg', 0.85);
  }
  function setFile(input, file) {
    var dt = new DataTransfer();
    dt.items.add(file);
    input.files = dt.files;
    input._fgSig = sig(input.files[0]);
  }
  function showError(input, msg) {
    var group = input.closest('.ccf-group') || input.parentElement;
    var err = group.querySelector('.fg-err');
    if (!msg) { if (err) err.remove(); return; }
    if (!err) { err = el('p', 'fg-err'); err.setAttribute('role', 'alert'); input.insertAdjacentElement('afterend', err); }
    err.textContent = msg;
  }

  /* ---------- Cropper ---------- */
  var C = null; // cropper elements and state

  function buildCropper() {
    var root = el('div', 'fg-crop');
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'fg-crop-title');
    root.innerHTML =
      '<div class="fg-crop__panel">' +
        '<div class="fg-crop__head"><h2 id="fg-crop-title" class="fg-crop__title">Position your photo</h2>' +
        '<button type="button" class="fg-crop__x" aria-label="Cancel">&times;</button></div>' +
        '<p class="fg-crop__sub">Drag to move. Pinch, scroll or use the slider to zoom.</p>' +
        '<div class="fg-crop__stage" tabindex="0" aria-label="Photo position. Use arrow keys to move and plus or minus to zoom.">' +
          '<canvas class="fg-crop__canvas"></canvas>' +
          '<div class="fg-crop__frame"><div class="fg-crop__safe"></div></div>' +
        '</div>' +
        '<p class="fg-crop__quality" aria-live="polite"></p>' +
        '<div class="fg-crop__zoomrow"><span aria-hidden="true">&minus;</span>' +
          '<input type="range" class="fg-crop__zoom" min="1" max="5" step="0.01" value="1" aria-label="Zoom">' +
          '<span aria-hidden="true">+</span></div>' +
        '<div class="fg-crop__tools">' +
          '<button type="button" class="fg-crop__rotate">&#8635; Rotate</button>' +
          '<div class="fg-seg fg-crop__layout" role="group" aria-label="Card layout">' +
            '<button type="button" class="fg-seg__btn" data-layout="landscape" aria-pressed="true">Landscape</button>' +
            '<button type="button" class="fg-seg__btn" data-layout="portrait" aria-pressed="false">Portrait</button>' +
          '</div>' +
          '<label class="fg-crop__bw"><input type="checkbox"> Black &amp; white</label>' +
        '</div>' +
        '<p class="fg-crop__tip">Keep faces and text inside the dashed line. The corners are rounded.</p>' +
        '<div class="fg-crop__actions">' +
          '<button type="button" class="fg-crop__cancel">Cancel</button>' +
          '<button type="button" class="btn fg-crop__ok">Use this photo</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);

    C = {
      root: root,
      stage: root.querySelector('.fg-crop__stage'),
      canvas: root.querySelector('.fg-crop__canvas'),
      frame: root.querySelector('.fg-crop__frame'),
      safe: root.querySelector('.fg-crop__safe'),
      zoom: root.querySelector('.fg-crop__zoom'),
      quality: root.querySelector('.fg-crop__quality'),
      title: root.querySelector('.fg-crop__title'),
      layoutGroup: root.querySelector('.fg-crop__layout'),
      bw: root.querySelector('.fg-crop__bw input'),
      ok: root.querySelector('.fg-crop__ok'),
      pointers: {},
      job: null
    };
    C.ctx = C.canvas.getContext('2d');

    C.zoom.addEventListener('input', function () { setZoom(parseFloat(C.zoom.value)); });
    root.querySelector('.fg-crop__rotate').addEventListener('click', function () {
      var p = C.job.p;
      p.rot = (p.rot + 90) % 360;
      p.u = 0.5; p.v = 0.5; p.zoom = 1;
      C.zoom.value = 1;
      draw();
    });
    C.layoutGroup.addEventListener('click', function (e) {
      var b = e.target.closest('[data-layout]');
      if (!b || !C.job) return;
      C.job.layout = b.getAttribute('data-layout');
      layoutCropper();
    });
    C.bw.addEventListener('change', function () { C.canvas.classList.toggle('is-bw', C.bw.checked); });
    root.querySelector('.fg-crop__x').addEventListener('click', cancelCrop);
    root.querySelector('.fg-crop__cancel').addEventListener('click', cancelCrop);
    C.ok.addEventListener('click', confirmCrop);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); cancelCrop(); }
    });
    C.stage.addEventListener('keydown', function (e) {
      var step = 12;
      if (e.key === 'ArrowLeft') move(step, 0);
      else if (e.key === 'ArrowRight') move(-step, 0);
      else if (e.key === 'ArrowUp') move(0, step);
      else if (e.key === 'ArrowDown') move(0, -step);
      else if (e.key === '+' || e.key === '=') setZoom(C.job.p.zoom * 1.1);
      else if (e.key === '-' || e.key === '_') setZoom(C.job.p.zoom / 1.1);
      else return;
      e.preventDefault();
    });

    // Drag with one finger or the mouse; pinch with two fingers.
    C.stage.addEventListener('pointerdown', function (e) {
      C.stage.setPointerCapture(e.pointerId);
      C.pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      C.pinch = null;
    });
    C.stage.addEventListener('pointermove', function (e) {
      var pt = C.pointers[e.pointerId];
      if (!pt || !C.job) return;
      var ids = Object.keys(C.pointers);
      if (ids.length === 1) {
        move(e.clientX - pt.x, e.clientY - pt.y);
      } else if (ids.length === 2) {
        var a = C.pointers[ids[0]], b = C.pointers[ids[1]];
        var before = Math.hypot(a.x - b.x, a.y - b.y);
        var midBefore = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        pt.x = e.clientX; pt.y = e.clientY;
        var after = Math.hypot(a.x - b.x, a.y - b.y);
        var midAfter = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        if (before > 0) setZoom(C.job.p.zoom * after / before);
        move(midAfter.x - midBefore.x, midAfter.y - midBefore.y);
        return;
      }
      pt.x = e.clientX; pt.y = e.clientY;
    });
    function endPointer(e) { delete C.pointers[e.pointerId]; }
    C.stage.addEventListener('pointerup', endPointer);
    C.stage.addEventListener('pointercancel', endPointer);
    C.stage.addEventListener('wheel', function (e) {
      if (!C.job) return;
      e.preventDefault();
      setZoom(C.job.p.zoom * Math.exp(-e.deltaY * 0.0015));
    }, { passive: false });
    window.addEventListener('resize', function () { if (C.job) layoutCropper(); });
  }

  function frameSize() {
    var job = C.job;
    return job.layout === 'portrait' ? { w: C.fh, h: C.fw } : { w: C.fw, h: C.fh };
  }
  function layoutCropper() {
    var job = C.job;
    C.root.classList.toggle('is-portrait', job.layout === 'portrait');
    var sw = C.stage.clientWidth, sh = C.stage.clientHeight;
    var fw, fh;
    if (job.layout === 'portrait') {
      fh = Math.min(sh * 0.86, sw * 0.86 * RATIO); fw = fh / RATIO;
    } else {
      fw = Math.min(sw * 0.86, sh * 0.86 * RATIO); fh = fw / RATIO;
    }
    C.fw = job.layout === 'portrait' ? fh : fw; // long side
    C.fh = job.layout === 'portrait' ? fw : fh; // short side
    var f = C.frame.style;
    f.width = fw + 'px'; f.height = fh + 'px';
    f.left = (sw - fw) / 2 + 'px'; f.top = (sh - fh) / 2 + 'px';
    f.borderRadius = job.layout === 'portrait' ? RAD_S + '% / ' + RAD_L + '%' : RAD_L + '% / ' + RAD_S + '%';
    var inset = SAFE * Math.max(fw, fh) + 'px';
    C.safe.style.top = C.safe.style.right = C.safe.style.bottom = C.safe.style.left = inset;
    var dpr = window.devicePixelRatio || 1;
    C.canvas.width = Math.round(sw * dpr); C.canvas.height = Math.round(sh * dpr);
    C.canvas.style.width = sw + 'px'; C.canvas.style.height = sh + 'px';
    C.layoutGroup.hidden = !job.allowLayout;
    C.layoutGroup.querySelectorAll('[data-layout]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-layout') === job.layout));
    });
    draw();
  }
  function draw() {
    var job = C.job; if (!job) return;
    var fs = frameSize();
    clampCenter(job.img, job.p, fs.w, fs.h);
    var dpr = window.devicePixelRatio || 1, ctx = C.ctx;
    var sw = C.canvas.width / dpr, sh = C.canvas.height / dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.fillStyle = '#111';
    ctx.fillRect(0, 0, sw, sh);
    var scale = coverScale(job.img, job.p.rot, fs.w, fs.h) * job.p.zoom;
    drawPhoto(ctx, job.src, job.img, job.p, sw / 2, sh / 2, scale);
    // Photo quality: photo pixels across the card width, per inch.
    var dpi = fs.w / scale / WIDTH_IN[job.layout];
    var q = C.quality;
    if (dpi >= 250) { q.textContent = 'Photo quality: Great'; q.className = 'fg-crop__quality is-great'; }
    else if (dpi >= 150) { q.textContent = 'Photo quality: Good'; q.className = 'fg-crop__quality is-good'; }
    else { q.textContent = 'Photo quality: Low. It may look blurry when engraved. Try zooming out or using a larger photo.'; q.className = 'fg-crop__quality is-low'; }
  }
  function move(dx, dy) {
    var job = C.job, fs = frameSize();
    var r = rotatedSize(job.img, job.p.rot);
    var scale = coverScale(job.img, job.p.rot, fs.w, fs.h) * job.p.zoom;
    job.p.u -= dx / scale / r.w;
    job.p.v -= dy / scale / r.h;
    draw();
  }
  function setZoom(z) {
    var job = C.job;
    job.p.zoom = Math.min(5, Math.max(1, z));
    C.zoom.value = job.p.zoom;
    draw();
  }

  function openCropper(input, file, saved) {
    if (!C) buildCropper();
    var box = input.closest('.card-custom-fields');
    var cfg = SIDES[modeOf(box)] || {};
    showError(input, '');
    var getImg = saved ? Promise.resolve(saved.img) : loadImage(file);
    getImg.then(function (img) {
      if (!img.naturalWidth) throw new Error('load');
      var side = sideOfInput(box, input);
      C.job = {
        input: input,
        box: box,
        side: side,
        img: img,
        src: saved ? saved.src : previewSource(img),
        p: saved ? { u: saved.p.u, v: saved.p.v, zoom: saved.p.zoom, rot: saved.p.rot } : { u: 0.5, v: 0.5, zoom: 1, rot: 0 },
        layout: layoutOf(box),
        startLayout: layoutOf(box),
        allowLayout: !!cfg.layout,
        file: saved ? saved.file : file
      };
      // A tall photo starts with a tall (portrait) card, unless the customer already chose a layout.
      if (!saved && cfg.layout && !box._fgLayoutChosen) {
        C.job.layout = img.naturalHeight > img.naturalWidth * 1.05 ? 'portrait' : 'landscape';
      }
      var twoPhotos = cfg.front && cfg.back && cfg.front.photo && cfg.back.photo;
      C.title.textContent = twoPhotos ? 'Position your ' + side + ' photo'
        : cfg.front && cfg.front.fixed ? 'Position your photo for the back'
        : 'Position your photo';
      C.zoom.value = C.job.p.zoom;
      C.bw.checked = false;
      C.canvas.classList.remove('is-bw');
      C.ok.disabled = false;
      C.ok.textContent = 'Use this photo';
      C.returnFocus = document.activeElement;
      C.root.hidden = false;
      document.documentElement.classList.add('fg-crop-open');
      layoutCropper();
      C.stage.focus({ preventScroll: true });
    }).catch(function () {
      restoreInput(input);
      showError(input, "We couldn't open that photo. Please choose a JPG or PNG file.");
    });
  }
  function closeCropper() {
    C.root.hidden = true;
    C.pointers = {};
    document.documentElement.classList.remove('fg-crop-open');
    var job = C.job;
    C.job = null;
    var back = job && (job.input._fgAdjust || job.input);
    if (back && back.focus) back.focus({ preventScroll: true });
  }
  // Put back the last confirmed photo, or clear the field.
  function restoreInput(input) {
    if (input._fgFile) setFile(input, input._fgFile);
    else input.value = '';
  }
  function cancelCrop() {
    if (!C.job) return;
    restoreInput(C.job.input);
    closeCropper();
  }
  function confirmCrop() {
    var job = C.job; if (!job) return;
    C.ok.disabled = true;
    C.ok.textContent = 'Saving...';
    var layoutChanged = job.allowLayout && job.layout !== job.startLayout;
    if (job.allowLayout) { job.box._fgLayout = job.layout; job.box._fgLayoutChosen = true; }
    applyCrop(job.input, { img: job.img, src: job.src, p: job.p, file: job.file }, job.layout, job.side).then(function () {
      closeCropper();
      if (layoutChanged) recropOthers(job.box, job.input);
      renderBox(job.box);
      showSide(job.box, job.side);
    }).catch(function () {
      C.ok.disabled = false;
      C.ok.textContent = 'Use this photo';
      C.quality.textContent = 'Something went wrong saving your photo. Please try again.';
      C.quality.className = 'fg-crop__quality is-low';
    });
  }
  function applyCrop(input, saved, layout, side) {
    return exportCrop(saved.img, saved.p, layout, side).then(function (res) {
      setFile(input, res.file);
      input._fgFile = input.files[0];
      input._fgSaved = saved;
      input._fgPreview = res.preview;
      addAdjustButton(input);
      // Let the field script show the new thumbnail.
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  // When the card layout changes, re-crop the other photos on the same card to match.
  function recropOthers(box, except) {
    var layout = layoutOf(box);
    var jobs = [];
    box.querySelectorAll('input[type="file"]').forEach(function (inp) {
      if (inp === except || !inp._fgSaved) return;
      jobs.push(applyCrop(inp, inp._fgSaved, layout, sideOfInput(box, inp)));
    });
    return Promise.all(jobs).then(function () { renderBox(box); });
  }
  function addAdjustButton(input) {
    if (input._fgAdjust) { input._fgAdjust.hidden = false; return; }
    var b = el('button', 'fg-adjust', 'Adjust photo');
    b.type = 'button';
    b.addEventListener('click', function () {
      if (input._fgSaved) openCropper(input, null, input._fgSaved);
    });
    var thumb = input.parentElement.querySelector('.ccf-thumb');
    (thumb || input).insertAdjacentElement('afterend', b);
    input._fgAdjust = b;
  }
  function clearPhoto(input) {
    input._fgFile = null; input._fgSaved = null; input._fgPreview = null; input._fgSig = '';
    if (input._fgAdjust) input._fgAdjust.hidden = true;
  }

  // Catch a newly chosen photo before the field script shows it, and open the cropper.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!canSwapFiles || !input.matches || !input.matches(FILE_SEL)) return;
    var f = input.files && input.files[0];
    if (!f) { clearPhoto(input); return; }
    if (input._fgSig && sig(f) === input._fgSig) return; // our own cropped file
    e.stopImmediatePropagation();
    if (f.size > MAX_BYTES) {
      restoreInput(input);
      showError(input, 'That photo is over 20 MB. Please choose a smaller one.');
      return;
    }
    if (f.type && f.type.indexOf('image/') !== 0) {
      restoreInput(input);
      showError(input, 'Please choose a photo (JPG or PNG).');
      return;
    }
    openCropper(input, f, null);
  }, true);

  /* ---------- 3D preview ---------- */
  function initBox(box) {
    if (box._fgReady) return;
    box._fgReady = true;
    var preview = box.querySelector('.fg-preview');
    box._fgLayout = 'landscape';
    box._fgAngle = 0;
    if (!preview) return;
    var card = preview.querySelector('.fg-card3d');
    var stage = preview.querySelector('.fg-stage');

    preview.querySelector('.fg-sides').addEventListener('click', function (e) {
      var b = e.target.closest('[data-side]');
      if (b) setAngle(box, b.getAttribute('data-side') === 'back' ? 180 : 0, true);
    });
    preview.querySelector('.fg-layout').addEventListener('click', function (e) {
      var b = e.target.closest('[data-layout]');
      if (!b) return;
      var next = b.getAttribute('data-layout');
      box._fgLayoutChosen = true;
      if (next === box._fgLayout) return;
      box._fgLayout = next;
      renderBox(box);
      recropOthers(box, null);
    });

    // Swipe sideways to turn the card; a tap flips it.
    var drag = null;
    stage.addEventListener('pointerdown', function (e) {
      drag = { x: e.clientX, y: e.clientY, start: box._fgAngle, moved: false, id: e.pointerId };
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 8) return;
      if (!drag.moved) {
        if (Math.abs(e.clientY - drag.y) > Math.abs(dx)) { drag = null; return; } // vertical scroll
        drag.moved = true;
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      setAngle(box, drag.start + dx * 180 / Math.max(160, stage.clientWidth * 0.8), false);
    });
    function end(e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (drag.moved) setAngle(box, Math.round(box._fgAngle / 180) * 180, true);
      else if (e.type === 'pointerup') setAngle(box, box._fgAngle + 180, true);
      drag = null;
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);

    box.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('textarea.fg-text')) return;
      updateCount(t);
      renderText(box);
      // Turn the card to the side being typed on.
      var cfg = SIDES[modeOf(box)];
      if (cfg) showSide(box, cfg.back && cfg.back.text === t.name ? 'back' : 'front');
    });
    box.querySelectorAll('textarea.fg-text').forEach(updateCount);
  }
  function showSide(box, side) {
    var a = ((box._fgAngle % 360) + 360) % 360;
    var isBack = a > 90 && a < 270;
    if ((side === 'back') !== isBack) setAngle(box, box._fgAngle + 180, true);
  }
  function setAngle(box, angle, animate) {
    var card = box.querySelector('.fg-card3d');
    if (!card) return;
    box._fgAngle = angle;
    // Portrait back on a message card: the card turns a quarter as it flips, so the
    // back photo or note reads upright (like turning a real card in your hand).
    var turn = card.getAttribute('data-turn') === 'back';
    var f = (1 - Math.cos(angle * Math.PI / 180)) / 2;
    var t = (turn ? 'rotate(' + (90 * f).toFixed(2) + 'deg) ' : '') + 'rotateY(' + angle + 'deg)';
    if (card.style.transform === t) return;
    card.classList.toggle('is-animating', !!animate && !reduceMotion);
    card.style.transform = t;
    var a = ((angle % 360) + 360) % 360;
    var back = a > 90 && a < 270;
    box.querySelectorAll('.fg-sides [data-side]').forEach(function (b) {
      b.setAttribute('aria-pressed', String((b.getAttribute('data-side') === 'back') === back));
    });
  }
  function updateCount(t) {
    var wrap = t.parentElement.querySelector('.fg-count');
    if (!wrap) return;
    var max = parseInt(t.getAttribute('maxlength'), 10) || 0;
    var n = t.value.length;
    wrap.querySelector('.fg-count__n').textContent = n;
    wrap.classList.toggle('is-near', max && n >= max * 0.9);
  }

  function faceInner(box, side) { return box.querySelector('.fg-face--' + side + ' .fg-face__inner'); }
  function fillFace(box, side, spec) {
    var inner = faceInner(box, side);
    if (!inner) return;
    var key;
    if (!spec) key = 'blank';
    else if (spec.fixed) key = 'fixed';
    else if (spec.photo) {
      var inp = field(box, spec.photo);
      key = 'photo:' + (inp && inp._fgPreview ? inp._fgSig : 'none');
    } else key = 'text:' + spec.text;
    if (inner._fgKey === key) return;
    inner._fgKey = key;
    inner.innerHTML = '';
    inner.className = 'fg-face__inner';
    if (!spec) { inner.classList.add('is-blank'); return; }
    if (spec.fixed) {
      var front = box.getAttribute('data-front-image');
      if (front) { var fi = el('img', 'fg-face__img is-front'); fi.alt = ''; fi.src = front; inner.appendChild(fi); }
      else { inner.classList.add('is-placeholder'); inner.appendChild(el('span', 'fg-ph', "Front: this card's message")); }
      return;
    }
    if (spec.photo) {
      var input = field(box, spec.photo);
      if (input && input._fgPreview) {
        var img = el('img', 'fg-face__img'); img.alt = ''; img.src = input._fgPreview; inner.appendChild(img);
      } else {
        inner.classList.add('is-placeholder');
        inner.appendChild(el('span', 'fg-ph', 'Your photo will appear here'));
      }
      return;
    }
    inner.classList.add('is-text');
    inner.appendChild(el('div', 'fg-face__text'));
  }
  function renderText(box) {
    var cfg = SIDES[modeOf(box)];
    if (!cfg) return;
    ['front', 'back'].forEach(function (side) {
      var spec = cfg[side];
      if (!spec || !spec.text) return;
      var inner = faceInner(box, side);
      var t = inner && inner.querySelector('.fg-face__text');
      var ta = field(box, spec.text);
      if (!t) return;
      var value = ta ? ta.value.trim() : '';
      var shown = value || 'Your message will appear here';
      // Only touch the page when something changed (keeps typing smooth).
      if (t.textContent !== shown) t.textContent = shown;
      t.classList.toggle('is-empty', !value);
      var key = shown + '|' + inner.clientWidth + '|' + inner.clientHeight;
      if (t._fgFit !== key) { t._fgFit = key; fitText(t, inner); }
    });
  }
  // Largest font size that fits inside the safe area of the card.
  function fitText(t, inner) {
    var cs = getComputedStyle(inner);
    var maxH = inner.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    var maxW = inner.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (maxH <= 0 || maxW <= 0) { t._fgFit = ''; return; }
    var fits = function () { return t.scrollHeight <= maxH + 0.5 && t.scrollWidth <= maxW + 0.5; };
    // Shrink until whole words fit; only split a word if it can't fit at all.
    t.style.overflowWrap = 'normal';
    var lo = 4, hi = t.classList.contains('is-empty') ? 15 : Math.max(8, Math.min(maxH * 0.17, 28));
    t.style.fontSize = hi + 'px';
    if (fits()) return;
    for (var i = 0; i < 12; i++) {
      var mid = (lo + hi) / 2;
      t.style.fontSize = mid + 'px';
      if (fits()) lo = mid; else hi = mid;
    }
    t.style.fontSize = lo + 'px';
    if (!fits()) t.style.overflowWrap = 'anywhere';
  }

  function renderBox(box) {
    initBox(box);
    var preview = box.querySelector('.fg-preview');
    var tips = box.querySelector('.fg-tips');
    var mode = modeOf(box);
    var cfg = SIDES[mode];
    var layoutInput = box.querySelector('.fg-layout-input');
    var hasPhoto = !!cfg && ['front', 'back'].some(function (s) { return cfg[s] && cfg[s].photo; });
    if (tips) tips.hidden = !hasPhoto;
    if (!preview) return;
    if (!cfg) {
      preview.hidden = true;
      if (layoutInput) layoutInput.disabled = true;
      return;
    }
    preview.hidden = false;
    var layout = layoutOf(box);
    var card = preview.querySelector('.fg-card3d');
    var turnBack = !!cfg.backOnly && layout === 'portrait';
    card.setAttribute('data-layout', cfg.backOnly ? 'landscape' : layout);
    if (turnBack) card.setAttribute('data-turn', 'back'); else card.removeAttribute('data-turn');
    preview.querySelector('.fg-stage').classList.toggle('has-turn', turnBack);
    preview.querySelector('.fg-layout').hidden = !cfg.layout;
    preview.querySelectorAll('.fg-layout [data-layout]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-layout') === layout));
    });
    if (layoutInput) {
      layoutInput.disabled = !cfg.layout;
      layoutInput.name = cfg.backOnly ? 'properties[Back Layout]' : 'properties[Card Layout]';
      layoutInput.value = layout === 'portrait' ? 'Portrait' : 'Landscape';
      var form = formFor(box), fid = form && form.getAttribute('id');
      if (fid) layoutInput.setAttribute('form', fid);
    }
    fillFace(box, 'front', cfg.front);
    fillFace(box, 'back', cfg.back);
    renderText(box);
    if (box._fgMode !== mode) {
      box._fgMode = mode;
      // Show the side the customer is editing: message cards only change the back.
      setAngle(box, cfg.front && cfg.front.fixed ? 180 : 0, false);
    } else {
      setAngle(box, box._fgAngle, true); // picks up a layout change
    }
  }

  var timer;
  function renderAll() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.querySelectorAll('.card-custom-fields').forEach(renderBox);
    }, 150);
  }
  document.addEventListener('change', renderAll);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-product-options], .product-section, quick-view, [class*="quick"]')) renderAll();
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.card-custom-fields').forEach(function (box) { if (box._fgReady) renderText(box); });
  });
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes.length) { renderAll(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll);
  else renderAll();
})();
